import { Injectable } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { take } from 'rxjs/operators';

import { IEnvironment } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class EnvironmentService {

  environment: IEnvironment;

  constructor(
    private store: Store<any>,
  ) {
    this.store
        .pipe(
          select('environment'),
          take(1),
        )
        .subscribe(state => {
          this.environment = state;
        });
  }

}
